import {
	PANEL_LEFT_SHOW_HIDE_CLICK,
	PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK
} from '../actions';

const INIT_STATE = {
	isLeftPanelHidden: true,
	isRightPanelHidden : true,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case PANEL_LEFT_SHOW_HIDE_CLICK:
			return { ...state, isLeftPanelHidden: !state.isLeftPanelHidden}
		case PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK:
			return { ...state, isRightPanelHidden: action.payload.isShow} 
		default: return { ...state };
	}
}
